export default [
  {
    id: 'nav-pody',
    title: 'Creative center',
    route: 'pody-creatives',
    icon: 'VideoIcon',
    tooltip: 'Pody',
  },
]
